import { Button, Dialog } from '@agro1desenvolvimento/react-components';
import './ModalConfirmacao.scss';

interface Props {
  title: string;
  description: string;
  buttonLabel?: string;
  onConfirm: () => void;
  visible?: boolean;
}

export default function ModalConfirmacao({
  title, description, buttonLabel, onConfirm, visible,
}: Props) {
  return (
    <Dialog
      className="modal-confirmacao-dialog"
      contentClassName="modal-confirmacao"
      visible={visible}
      closeOnEscape
      dismissableMask
      onHide={onConfirm}
      showHeader={false}
    >
      <h4 className="modal-confirmacao__title">{title}</h4>
      <p className="modal-confirmacao__description">{description}</p>
      <Button
        className="modal-confirmacao__button"
        onClick={onConfirm}
      >
        {buttonLabel ?? 'Ok'}
      </Button>
    </Dialog>
  );
}
